<template>

<button class="button" :class="{'is-dark': dark, 'is-invert': invert, 'is-loading': loading}" v-on:click="$emit('click')">
	
	<span><slot></slot></span>
	
</button>

</template>

<script>

export default {

	props: ['dark', 'loading', 'invert']

}

</script>

<style scoped>

.button {
	padding: 0px 32px;
	height: 48px;
	border-radius: 24px;
	border: 2px solid var(--primary-color);
	font-size: 18px;
	font-weight: 700;
	display: inline-block;
	color: #343434;
	transition: border-color 300ms ease-in-out, background-color 300ms ease-in-out;
}

.button.is-invert {
	background-color: var(--primary-color);
	color: #fff;
}

.is-aiding .button {
	border: 2px solid var(--aid-color);
}

.button.is-dark {
	color: #fff;
}

.button.is-active {
	background-color: #343434;
	border-color: #343434;
	color: #fff;
}

.button:not(.is-active):hover {
	background-color: var(--primary-color);
	color: #fff;
}

.is-aiding .button:not(.is-active):hover {
	background-color: var(--aid-color);
}

.button.is-invert:hover {
	border: 2px solid var(--primary-color);
	background-color: #fff;
	color: var(--primary-color);
}

.button.is-loading {
	pointer-events: none;
	background-image: url(~@/assets/load.gif);
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-color: var(--aid-color);
	border-color: var(--aid-color);
}

.button.is-loading span {
	visibility: hidden;
}

</style>